import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 16, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, index }) => (
  <div className="flex items-center gap-3 mb-5">
    {index && (
      <span className="font-serif italic text-clinic-rose text-lg">{index}</span>
    )}
    <span className="h-px w-8 bg-clinic-rose/60" />
    <span className="font-sans text-xs uppercase tracking-[0.35em] text-clinic-muted">
      {children}
    </span>
  </div>
);
